module.exports = {
  en: require('./en.json')
};



//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/locale/index.js
// module id = 663
// module chunks = 2 3